import { Route, Routes } from 'react-router'
import TransactionView from './view'
import "./transactions.css"
import { PermissionGuard } from '../../newComponents/PermissionGuard'
import { AccessLevelEnum } from '@propertelligent/client-api'
import NoAccess from '../../pages/NoAccess'

const Transaction = () => {
    return (
        <Routes>
            <Route
                index
                element={
                    <PermissionGuard
                        permission="Transaction"
                        level={AccessLevelEnum.ReadOnly}
                        fallback={<NoAccess />}
                    >
                        <TransactionView />
                    </PermissionGuard>
                }
            />
        </Routes>
    )
}

export default Transaction;